import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import Pagination from '../Pagination/Pagination';
import Search from '../Search/Search';
import TileView from '../TileView/TileView';
import Users from '../Users/Users';
import './Home.css';

const Home = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage] = useState(10);
    const [query, setQuery] = useState('');
    const [gender, setGender] = useState('');
    const [toggle, setToggle] = useState(false);


    useEffect(() => {
        setLoading(true);
        fetch(`https://randomuser.me/api/?results=50&gender=${gender}`)
            .then(res => res.json())
            .then((result) => {
                setUsers(result.results);
                // setusers(result.results);
                setLoading(false);
            })
    }, [gender])

    // Get current users
    const indexOfLastPost = currentPage * usersPerPage;
    const indexOfFirstPost = indexOfLastPost - usersPerPage;
    const currentUsers = users.slice(indexOfFirstPost, indexOfLastPost)

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Switch
    const toggler = () => {
        toggle ? setToggle(false) : setToggle(true);
    }



    return (
        <div className="container">
            <h2 className="my-4">User List</h2>
            <Header toggler={toggler} setGender={setGender} />
            {/* <Search getQuery={(q) => setQuery(q)} /> */}
            {
                toggle ? <TileView users={currentUsers} loading={loading} /> : <Users users={currentUsers} loading={loading} />
            }
            <Pagination usersPerPage={usersPerPage} totalUsers={users.length} paginate={paginate} />
        </div>
    );
};

export default Home;